// extracted by mini-css-extract-plugin
module.exports = {"container":"container___IWNJy","isActive":"isActive___3oFC1","slideCount":"slideCount___30MNH","slideInfo":"slideInfo___3gehI"};